import { Observable } from 'rxjs';
import { ResponseOk, GetMembers, Autocomplete, AutocompleteResponse } from './../../core/models/team-management.model';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TeamManagementService {
  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { }

  public uri = this.environmentService.getEnvVar('api_leads');

  getTeam(data: GetMembers): Observable<ResponseOk> {
    const path = 'team/members';
    return this.http.post<ResponseOk>(`${this.uri}/${path}`, data);
  }

  autocomplete(search: Autocomplete): Observable<AutocompleteResponse> {
    const path = 'team/autocomplete';
    return this.http.post<AutocompleteResponse>(`${this.uri}/${path}`, search);
  }

  getActiveCampaignsCount() {
    return this.http.get<any>(`${this.uri}/campaigns/count`);
  }

}
